export default function Copyright() {
  return (
    <p className="sm:text-sm text-xs text-center text-gray-500 mx-2 mt-2 mb-8">
      &copy; 2025 <a href="https://aristorinjuang.com">Aristo Rinjuang</a>
    </p>
  )
}
